<div class="d-flex w100 justify-content-center">
  <img class="title-logo" [style.width]="size" [src]="small ? 'assets/images/small-logo.png' : 'assets/images/logo.png'"
       alt="logo" style="user-select: none;" />
</div>
